var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('van-loading',{attrs:{"color":"#00bb5a","size":"32"}},[_vm._v("加载中...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }